export default "__VITE_PUBLIC_ASSET__ac483e13__"